// ./scr/store/modules/geolocation/actions.js

export default {
  setLockViewToCenter ({ commit }, bool) {
    commit('SET_LOCK_VIEW_TO_CENTER', bool)
  },
  setTemporaryCenterOfManuallyMovedMap ({ commit }, payload) {
    commit('SET_TEMPORARY_CENTER_OF_MANUALLY_MOVED_MAP', payload)
  },
  // For display of geodata on screen => TODO: must this be a vuex store var?
  setCurrentGeolocation ({ commit }, payload) {
    commit('SET_CURRENT_GEO_POSITION', payload)
  },
  setCurrentDistance ({ commit }, val) {
    commit('SET_CURRENT_DISTANCE', val)
  },
  setGeoPositionCenter ({ commit }, payload) {
    commit('SET_GEO_POSITION_CENTER', payload)
  }
}
